/**
 * SFN i18n — Русский (ru-RU). Overlays EN base with professional translations
 * for every REQUIRED_I18N_KEYS entry.
 */
import type { Dict } from "./types";
import { en } from "./en";

export const ru: Dict = {
  ...en,

  // Navigation
  "nav.home": "Главная",
  "nav.about": "О нас",
  "nav.contact": "Контакты",
  "nav.ecosystem": "Экосистема",
  "nav.tokens": "Токены",
  "nav.protection": "Защита",
  "nav.secure": "Забронировать",
  "nav.faq": "Вопросы и ответы",
  "nav.connectWallet": "Подключить кошелёк",
  "nav.language": "Язык",

  // Hero
  "hero.eyebrow": "Подтверждённая защита от инфляции за $1 на Solana",
  "hero.stat1": "Обедов обеспечено",
  "hero.stat2": "Обеспечение реальными активами",
  "hero.stat3": "Средний расчёт",

  // Bento
  "bento.title": "Sustainable Food & Eco Network (SFN): как это работает",
  "bento.sub": "Токеномика, полезность и устойчивость — собраны как дегустационное меню.",
  "bento.card1.title": "Видение и сеть (SFN)",
  "bento.card1.text":
    "SFN — открытая децентрализованная сеть сертифицированных партнёрских кухонь, локальных фермеров и сторонников. Объединяя финансирование сообщества и работу на солнечной энергии, мы удерживаем себестоимость продовольствия на предельно низком и стабильном уровне.",
  "bento.card2.title": "Децентрализованный региональный хаб закупок",
  "bento.card2.text":
    "Наш якорный объект — живой полигон, где каждый день на практике проверяется концепция обеда за 30 THB. Отсюда координируются оптовые закупки, солнечная инфраструктура кухонь и операционные стандарты, которые наследует каждая партнёрская точка.",
  "bento.card3.title": "Масштабируемое глобальное влияние",
  "bento.card3.text":
    "Мы не останавливаемся на одной кухне. SFN спроектирована для роста. Международные сторонники могут спонсировать обеды в цифровом виде, а традиционные местные харчевни — присоединяться к сети, получая доступ к субсидированным ингредиентам и солнечной энергии.",

  // Pilot / Sandbox
  "pilot.eyebrow": "Живой пилот Proof of Concept: Thailand Sandbox",
  "pilot.title": "Таиланд: пилотный рынок фазы 1 (зона песочницы)",
  "pilot.body":
    "Запуск на высокоэффективном региональном рынке позволяет провести стресс-тест токеномики MEAL4/MEAL2 и реальной цепочки поставок с максимальным операционным контролем. Каждая кухня, каждый поток ингредиентов и каждый маршрут расчётов проверяются в замкнутой среде до международного масштабирования SFN.",
  "pilot.benchmark.label": "Глобальный ориентир — $1",
  "pilot.benchmark.value": "$1",
  "pilot.benchmark.desc": "Мы привязываем стоимость обеда к 30 THB ($1) или ниже, используя локализованные Web3-механизмы, доказывающие глобальную масштабируемость.",
  "pilot.phase1": "Фаза 1: региональный пилот ($1)",
  "pilot.phase2": "Фаза 2: глобальное масштабирование",
  "pilot.phase.arrow": "Маршрут дорожной карты",
  "pilot.stat1.label": "Пилотный рынок",
  "pilot.stat1.value": "Таиланд · Кхаойой",
  "pilot.stat2.label": "Якорь обеда",
  "pilot.stat2.value": "$1",
  "pilot.stat3.label": "Следующая фаза",
  "pilot.stat3.value": "Глобальный запуск",

  // About
  "about.eyebrow": "Основатели и миссия",
  "about.titleA": "За кулисами",
  "about.titleB": "Sustainable Food & Eco Network",
  "about.body":
    "SFN основана предпринимательской командой, соединяющей классическое немецкое бизнес-администрирование и реальный тайский общепит. Увидев, как глобальная инфляция бьёт по локальным сообществам, мы решили направить блокчейн не на спекуляции, а на базовую стабильность человека. Наша пилотная кухня в провинции Пхетчабури, Таиланд, служит операционной моделью для прозрачного, работающего на солнце и децентрализованного будущего продовольственной безопасности.",

  // Contact
  "contact.eyebrow": "Запрос на партнёрство",
  "contact.titleA": "Присоединяйтесь",
  "contact.titleB": "к сети",
  "contact.body":
    "Вы — локальная кухня, готовая принимать MEAL, фермер, желающий поставлять напрямую, или международный сторонник с вопросом? Напишите нам.",
  "contact.name": "Имя",
  "contact.namePh": "Ваше имя",
  "contact.email": "Email",
  "contact.emailPh": "you@example.com",
  "contact.subject": "Тема",
  "contact.subjectPh": "Партнёрство, поставки, поддержка…",
  "contact.message": "Сообщение",
  "contact.messagePh": "Расскажите о вашем проекте или вопросе…",
  "contact.sent": "Сообщение отправлено безопасно",
  "contact.successBody":
    "Ваше сообщение доставлено через зашифрованный канал. Мы ответим в течение 48 часов.",
  "contact.errorTitle": "Не удалось отправить",
  "contact.errorBody": "Не удалось доставить сообщение. Проверьте соединение и попробуйте снова.",
  "contact.dismissOk": "Отправить ещё",
  "contact.dismissError": "Повторить",
  "contact.responseNote": "Обычно отвечаем в течение 48 часов.",
  "contact.send": "Отправить сообщение",

  // Dual-token
  "dual.eyebrow": "Двухтокенная архитектура",
  "dual.title": "Двухтокенная система: защита и полезность",
  "dual.sub":
    "MEAL4 переносит ценность. MEAL2 удерживает её на месте. Вместе они делают продовольственную безопасность реально расходуемой.",
  "dual.meal4.t": "MEAL4 — Инфляционный щит",
  "dual.meal4.d":
    "Строго ограничен 1 000 000 токенов без возможности когда-либо выпустить больше. MEAL4 — цифровой контракт, обеспеченный резервами физических активов и стратегической силой оптовых закупок. Он замораживает стоимость производства еды у истока и формирует дефляционный хедж против роста рыночных цен.",
  "dual.meal2.t": "MEAL2 — Ежедневная утилита",
  "dual.meal2.d":
    "Практичный повседневный токен для плавной работы ресторанов, программ лояльности и социальной помощи. MEAL2 приводит экосистему в движение: мгновенные мобильные платежи, скидки для постоянных гостей и прозрачные цифровые спонсорства обедов от глобальной аудитории.",

  // Protection
  "protection.eyebrow": "Неизменяемая безопасность · Он-чейн",
  "protection.title": "Необратимое доверие, заложенное в код",
  "protection.sub":
    "Мы жёстко прописали строгие параметры безопасности в смарт-контрактах, защищая сообщество от инфляции и несанкционированных изменений.",
  "protection.f1.title": "100% активы, защищённые от заморозки",
  "protection.f1.text":
    "«Freeze Authority» для обоих токенов навсегда отозвана. Ни центральная власть, ни институт, ни разработчик не смогут заморозить ваш кошелёк или запретить использовать MEAL.",
  "protection.f2.title": "Жёстко заданный лимит эмиссии (MEAL4)",
  "protection.f2.text":
    "«Mint Authority» для MEAL4 необратимо уничтожена. Математически невозможно выпустить более 1 000 000 MEAL4, что навсегда защищает ваш продовольственный хедж от размывания.",
  "protection.f3.title": "Гибкий рост утилиты (MEAL2)",
  "protection.f3.text":
    "Мы сознательно сохранили возможность минтинга для MEAL2, чтобы бесшовно масштабироваться вместе с новыми партнёрскими кухнями в SFN и обеспечивать локальные экономики достаточным транзакционным топливом.",

  // Swap
  "swap.eyebrow": "Продажа токенов",
  "swap.title": "Забронируйте свои обеды",
  "swap.sub":
    "Свопайте напрямую в MEAL4. Каждый токен гарантирует один обед в нашей партнёрской кухне — сегодня, завтра и после любого кризиса.",
  "swap.connectWallet": "Подключите кошелёк для свопа",
  "swap.meal4.milestoneLabel":
    "Текущая веха: цель фазы 1 — инфраструктура центральной кухни Thailand Sandbox и первое расширение Express",
  "swap.meal4.milestoneProgress": "Собрано {raised} / {goal} USDC",
  "swap.meal4.percent": "Профинансировано на {pct}%",
  "swap.meal4.treasuryLabel": "Кошелёк казны проекта",
  "swap.meal4.treasuryNote":
    "Взносы поступают напрямую в казну SFN — без DEX и маршрутизации через открытый рынок.",
  "swap.meal4.tooltip":
    "Распределение токенов подкреплено физическими запасами и управляется по этапам финансирования для ценовой стабильности.",
  "swap.meal4.tooltipAria": "Как работает этапное финансирование",
  "swap.meal2.rateLabel": "Фиксированный курс · 1 USDC = 1 MEAL2",
  "swap.meal2.payWith": "Оплата в",
  "swap.meal2.solRoute": "Авто-маршрут: SOL → USD (Jupiter) → MEAL2 по $1 за единицу",
  "swap.meal2.priceFallback": "справочная цена (фид недоступен)",
  "swap.phantomApproving": "Ожидание подтверждения в Phantom…",

  // Trust
  "trust.eyebrow": "Прозрачность и доверие",
  "trust.title": "Обеспечено тем, к чему можно прикоснуться.",
  "trust.body":
    "Экосистема опирается на физические активы: партнёрский ресторан «Пилотная кухня SFN» в Таиланде, недвижимость и действующую кухню, где ежедневно подают реальные блюда. Мы открыто раскрываем регионы и операции — точные адреса скрыты ради безопасности команды и гостей.",

  // FAQ
  "faq.eyebrow": "Вопросы и ответы",
  "faq.title": "Часто задаваемые вопросы",
  "faq.sub":
    "Всё, что нужно знать о Sustainable Food & Eco Network (SFN) и нашей экосистеме стабилизации питания.",
  "faq.q1": "Как вы гарантируете здоровый и качественный обед за $1 несмотря на инфляцию?",
  "faq.a1":
    "Мы объединяем три опоры: стратегические оптовые закупки сырья напрямую у местных фермеров, снижение операционных расходов ресторанов за счёт солнечной энергетики и поддержку сообществом через инфляционный щит MEAL4. Это полностью отрывает базовую цену нашей кухни от рыночной инфляции.",
  "faq.q2": "Справится ли один ресторан со спросом при масштабировании токена?",
  "faq.a2":
    "Нет, и не должен. «Пилотная кухня SFN» — наш реальный proof of concept, а верхнеуровневая архитектура — это SFN. По мере роста спроса независимые локальные кухни присоединяются к сети и получают доступ к субсидированным ингредиентам и инфраструктуре, распространяя обещание 30 THB по миру.",
  "faq.q3": "Как участвовать международным сторонникам, не живущим в Таиланде?",
  "faq.a3":
    "Глобальные сторонники могут приобрести MEAL2 и запустить цифровое «спонсорство обедов». Эти токены прозрачно направляются в локальные социальные программы, позволяя пожилым, малоимущим семьям и уязвимым группам питаться бесплатно или за 30 THB в любой сертифицированной кухне SFN.",
  "faq.q4": "Чем MEAL4 отличается от обычной криптовалюты?",
  "faq.a4":
    "В отличие от спекулятивных токенов, MEAL4 — практический контракт, обеспеченный расширением реальных продовольственных резервов и устойчивой инфраструктуры общепита. Полностью уничтоженная эмиссия делает его математически ограниченным средством сбережения ради продовольственной безопасности.",

  // Roadmap
  "roadmap.eyebrow": "Исполнение · Траектория",
  "roadmap.title": "От заводского цеха к глобальному протоколу",
  "roadmap.sub":
    "Шестистадийная история реальной итерации. Каждый рубеж укоренён в операционной реальности, а не в презентациях.",
  "roadmap.card1.title": "Питание для заводских рабочих",
  "roadmap.card1.desc":
    "Наблюдение за тем, как ежедневная продуктовая инфляция перевалила за 45 THB за обед и всё больше вытесняет рабочих и малоимущие сообщества из зоны доступного здорового питания.",
  "roadmap.card2.title": "Концепция рамки $1",
  "roadmap.card2.desc":
    "Спроектирован экономический каркас, нацеленный на стабильную маржу в 30 THB — фундамент постоянно доступного и качественного обеда.",
  "roadmap.card3.title": "Тесты цепочки поставок",
  "roadmap.card3.desc":
    "Проведены пилоты закупок напрямую у фермеров, выявлены структурные ограничения модели одной точки и обоснована необходимость децентрализованного регионального хаба закупок.",
  "roadmap.card4.title": "Масштабирование сети и солнечные корни",
  "roadmap.card4.desc":
    "Расширение до нескольких точек выявило устойчивые энергетические расходы и подтвердило солнечную инфраструктуру как недостающий слой стабилизации затрат.",
  "roadmap.card5.title": "Операционное доказательство и пилот $1",
  "roadmap.card5.desc":
    "Достигнута абсолютная стабильность продаж на протяжении всего месяца — без просадок в середине — доказавшая операционную устойчивость модели 30 THB при масштабировании.",
  "roadmap.card6.title": "Токенизация SFN и спринт SolarPando",
  "roadmap.card6.desc":
    "Официальный запуск SFN на Solana: генезис токенов MEAL4 и MEAL2, верификация неизменяемости и спринт инфраструктуры SolarPando.",

  // Docs
  "docs.eyebrow": "База знаний",
  "docs.title": "White Paper и правовые документы",
  "docs.sub": "Скачайте официальную документацию SFN и отчёты аудита.",
  "credits.line": "Концепция и структура: Boy Khomkrit — первая публикация: 4 июля 2021 г.",
  "credits.date": "Дата создания оригинала: 4 июля 2021 г. (04.07.2021)",
  "credits.version": "Whitepaper v1.0 — первый выпуск: 4 июля 2021 г.",
  "docs.btn1": "White Paper экосистемы SFN (EN)",
  "docs.btn2": "Краткое резюме по токеномике (DE)",
  "docs.btn3": "Правовая рамка общепита Таиланда",
  "docs.btn4": "Отчёт криптографического аудита",

  // Verify
  "verify.meal4.title": "MEAL4 — верификация Инфляционного щита",
  "verify.meal4.sub": "Неизменяемые параметры актива",
  "verify.meal4.cta": "Открыть MEAL4 в Solana Explorer",
  "verify.meal2.title": "MEAL2 — верификация ежедневной утилиты",
  "verify.meal2.sub": "Гибкие параметры утилиты",
  "verify.meal2.cta": "Открыть MEAL2 в Solana Explorer",
  "verify.item.meal4Supply.label": "Лимит эмиссии MEAL4 подтверждён",
  "verify.item.meal4Supply.statusPassed": "УСПЕХ — ограничено 1 000 000",
  "verify.item.meal4Supply.statusLive": "УСПЕХ — он-чейн эмиссия: ",
  "verify.item.meal4Mint.label": "Mint Authority MEAL4",
  "verify.item.meal4Mint.statusPassed": "УСПЕХ — уничтожена (жёсткий лимит 1M)",
  "verify.item.meal4Mint.statusActive": "АКТИВНА — Mint Authority присутствует",
  "verify.item.meal4Freeze.label": "Freeze Authority MEAL4",
  "verify.item.meal4Freeze.statusPassed": "УСПЕХ — отозвана (нет центрального контроля)",
  "verify.item.meal4Freeze.statusActive": "АКТИВНА — Freeze Authority присутствует",
  "verify.item.meal2Freeze.label": "Freeze Authority MEAL2",
  "verify.item.meal2Freeze.statusPassed": "УСПЕХ — отозвана (ликвидность разблокирована)",
  "verify.item.meal2Freeze.statusActive": "АКТИВНА — Freeze Authority присутствует",
  "verify.item.meal2Mint.label": "Mint Authority MEAL2",
  "verify.item.meal2Mint.statusRevoked": "ОТОЗВАНА — эмиссия заморожена",
  "verify.item.meal2Mint.statusActive": "АКТИВНА — управляется SFN Growth Protocol",
  "verify.item.meal2Supply.label": "Оборотная эмиссия MEAL2",
  "verify.item.meal2Supply.statusLive": "LIVE — ",
  "verify.badge.connecting": "Соединение",
  "verify.badge.cached": "Кэш",
  "verify.badge.verified": "Проверено",
  "verify.networkBusy": "Сеть занята, повторное подключение… (попытка ",

  // Transparency
  "transparency.jsonImmutable": "// Неизменяемо. Нельзя изменить.",
  "transparency.jsonCeiling": "// Жёстко заданный потолок.",

  // Connection
  "connection.eyebrow": "// Связь",
  "connection.step1.title": "Оптовые закупки",
  "connection.step1.text":
    "Резервы MEAL4 финансируют прямые крупные закупки у местных фермеров, фиксируя стоимость ингредиентов ниже рыночной инфляции.",
  "connection.step2.title": "Солнечная инфраструктура",
  "connection.step2.text":
    "Автономные солнечные массивы обеспечивают партнёрские кухни электроэнергией 24/7, устраняя энергетическую волатильность из стоимости блюда.",
  "connection.step3.title": "Обмен на реальный обед",
  "connection.step3.text":
    "Гость сканирует, платит в MEAL2 и получает горячее и питательное блюдо менее чем за 1 USD — цифровой контракт исполняется за реальным столом.",

  // Barometer
  "barometer.eyebrow": "LIVE · Он-чейн · Проверено",
  "barometer.title.a": "Реальный",
  "barometer.title.b": "Инвентарный барометр",
  "barometer.sub":
    "Прозрачное окно в физические резервы, обеспечивающие каждый обед. Показатели обновляются с пилотной кухни — никаких домыслов, только запасы.",
  "barometer.rice": "Запасы риса",
  "barometer.oil": "Растительное масло",
  "barometer.solar": "Статус солнечной энергии",

  // Footer
  "footer.tag":
    "SFN (Sustainable Food & Eco Network) и MealToken24 применяют блокчейн-технологии против инфляции и мировой продовольственной нестабильности. Приводится в движение реальными кухнями, создан для реальных людей.",
  "footer.disclaimer":
    "Отказ от ответственности: MEAL2 и MEAL4 — утилитарные и обеспеченные активами токены сообщества, предназначенные для практического использования в экосистеме общепита Sustainable Food & Eco Network. Они не являются финансовыми инвестициями или традиционными ценными бумагами.",
  "footer.about": "О проекте",
  "footer.contact": "Контакты",
  "footer.legal": "Правовая информация",
  "footer.rights": "Все права защищены.",

  // Milestones
  "milestones.eyebrow": "БЛИЖАЙШАЯ ДОРОЖНАЯ КАРТА: СОЕДИНЕНИЕ БЛОКЧЕЙНА И ФИЗИЧЕСКОЙ ИНФРАСТРУКТУРЫ",
  "milestones.p1.title": "Центральный кухонный хаб SFN (Кхаойой)",
  "milestones.p1.desc":
    "Финансируемое институциональным капиталом автоматизированное центральное перерабатывающее предприятие возьмёт на себя оптовые закупки, солнечное холодоснабжение и безотходную готовку. Это устраняет издержки посредников и гарантирует ценовую стабильность до дистрибуции.",
  "milestones.p1.target": "100% солнечная взаимосвязанная цепочка поставок.",
  "milestones.p2.title": "Гипер-масштабирование Smart Express-точек",
  "milestones.p2.desc":
    "Масштабирование проверенной модели общепита из якорной точки в региональную сеть высокоэффективных экспресс-кухонь на ключевых магистралях. Каждая точка работает на субсидируемых энергосетях с нулевой стоимостью.",
  "milestones.p2.target": "Мультилокационное развёртывание региональной песочницы.",

  // VillagePando additions (Phase A)
  "vp.swap.pegged.badge": "Ваучер 1:1 с обеспечением USDC",
  "vp.swap.pegged.tooltip":
    "Каждый ваучер VillagePando обеспечен 1:1 резервом USDC и в любой момент может быть погашен по номиналу.",
  "vp.swap.tax.eyebrow": "5% солнечный налог",
  "vp.swap.tax.title": "Куда идут эти 5%?",
  "vp.swap.tax.intro":
    "5%, автоматически удерживаемые с каждой транзакции, на 100% направляются в верифицируемую публичную инфраструктуру — никакой проектной прибыли.",
  "vp.swap.tax.total": "Итого налог",
  "vp.swap.tax.perTx": "За транзакцию",
  "vp.swap.tax.hardware.label": "Фонд солнечного оборудования",
  "vp.swap.tax.hardware.detail":
    "Закупка автономных солнечных панелей, инверторов и накопителей для партнёрских кухонь и деревенских узлов.",
  "vp.swap.tax.reforestation.label": "Лесовосстановление и земля",
  "vp.swap.tax.reforestation.detail":
    "Финансирование посадки местных пород и восстановления почв на зарегистрированных участках с фиксацией в блокчейне.",
  "vp.swap.tax.ops.label": "Операции и комплаенс",
  "vp.swap.tax.ops.detail":
    "Покрывает обслуживание оборудования, обучение монтажников и комплаенс в разных юрисдикциях.",
  "vp.nexus.trio.eyebrow": "// Pando-Trio · Циклический поток",
  "vp.nexus.trio.caption":
    "Земля питает воду. Вода питает энергию. Энергия выкупает обед. Обед финансирует деревню.",
  "vp.nexus.trio.step1": "Земля → Вода",
  "vp.nexus.trio.step2": "Вода → Энергия",
  "vp.nexus.trio.step3": "Энергия → Выкуп обедов",
  "vp.nexus.trio.step4": "Обеды → Деревня",
  "nav.tokenomics": "Токеномика",
  "nav.roadmap": "Дорожная карта",
  "nav.vision": "Миссия",
  "nav.whitepaper": "White Paper",

  // Treasury transparency & purchase receipt
  "treasury.eyebrow": "Прозрачность расчётов",
  "treasury.title": "Каждая покупка MEAL2 и MEAL4 поступает в единое казначейство",
  "treasury.desc": "Покупки не проходят через DEX или промежуточные кошельки. Полный адрес получателя виден при наведении и проверяется в сети до разблокировки кнопок.",
  "treasury.label": "Казначейство проекта",
  "treasury.network": "Сеть",
  "treasury.copy": "Скопировать адрес",
  "treasury.copied": "Скопировано",
  "treasury.explorer": "Открыть в обозревателе",
  "treasury.status.checking": "Проверка адреса получателя",
  "treasury.status.verified": "Адрес получателя проверен",
  "treasury.status.degraded": "Адрес корректен · сеть перегружена",
  "treasury.status.invalid": "Адрес не проверен — покупки отключены",
  "receipt.eyebrow": "Транзакция исполнена",
  "receipt.title": "Подтверждение покупки",
  "receipt.desc": "Ваш взнос направлен в казначейство проекта SFN. Сохраните подпись ниже как подтверждение расчёта.",
  "receipt.amount": "Оплачено",
  "receipt.received": "Получено",
  "receipt.destination": "Адрес казначейства",
  "receipt.network": "Сеть",
  "receipt.hash": "Подпись транзакции",
  "receipt.viewExplorer": "Посмотреть транзакцию в обозревателе",
  "receipt.close": "Закрыть подтверждение",
  "receipt.copyHash": "Копировать хеш",
  "receipt.hashCopied": "Хеш скопирован",
  "receipt.download": "Скачать JSON",
  "rpc.checking": "Проверка адреса в сети…",
  "rpc.degraded": "Сеть перегружена — адрес корректен, проверка в блокчейне повторяется",
  "rpc.invalid": "Адрес не подтверждён — покупки отключены",

  // Analytics consent
  "consent.title": "Согласие на аналитику",
  "consent.desc": "Мы используем анонимную аналитику без cookie (без IP и отпечатков браузера), чтобы улучшать страницу. До вашего согласия ничего не отправляется.",
  "consent.accept": "Принять",
  "consent.decline": "Отклонить",
  "meal2.tab.web3": "Цифровой обмен (Web3)",
  "hero.title": "Замораживаем цену на еду: здоровый обед за $1 — навсегда.",
  "hero.sub": "Простая утилита. Реальная инфраструктура. На базе Meal2 и Meal4.",
  "hero.badge": "Первая в мире двухтокенная продовольственная инфраструктура — защита от продовольственной инфляции, обед за $1 за раз.",
  "hero.cta": "Купить Meal2 ($1 обед)",
  "hero.ghost": "Получить Meal4 (управление)",
  "keep.title": "Как мы удерживаем обед за $1",
  "keep.sub": "Три реальных актива поглощают рост издержек, поэтому цена тарелки не меняется.",
  "keep.solar.title": "Солнечная энергия",
  "keep.solar.text": "Автономные солнечные станции питают кухни и убирают счета за электричество из стоимости обеда.",
  "keep.agri.title": "Сельское хозяйство",
  "keep.agri.text": "Прямые закупки у ферм и лесовосстановление фиксируют стоимость ингредиентов без посредников.",
  "keep.water.title": "Чистая вода",
  "keep.water.text": "Фильтрованные резервуары обеспечивают ежедневное производство в сухой сезон без переменных затрат.",
  "brand.tagline": "Движок питания за $1",
  "nav.product": "Продукт",
  "nav.pilot": "Пилотные кухни",
  "trustpilot.eyebrow": "Proof of Concept · пилотный регион",
  "trustpilot.title": "Доказано в Таиланде — масштабируем глобально.",
  "trustpilot.desc": "Наша якорная кухня и общественный хаб уже работают. Каждый механизм, описанный здесь, проверяется на реальных блюдах, фермерах и сообществах до масштабирования.",
  "trustpilot.b1": "Якорная кухня работает ежедневно",
  "trustpilot.b2": "Региональная сеть фермеров",
  "trustpilot.b3": "Общественный хаб на солнечной энергии",
  "trustpilot.b4": "Ончейн-расчёты уже работают",
  "swap.quote.title": "Актуальная котировка маршрута",
  "swap.quote.slippage": "Макс. проскальзывание",
  "swap.quote.expiry": "Срок действия котировки",
  "swap.quote.minReceive": "Минимум к получению",
  "swap.quote.usdValue": "Оценочная стоимость",
  "swap.quote.expiresIn": "Обновление через {s} с",
  "swap.quote.expired": "Котировка устарела — обновите",
  "swap.quote.refresh": "Обновить котировку",
  "swap.quote.expiredError": "Котировка истекла. Обновите курс и повторите попытку.",
  "swap.quote.slippageError": "Курс SOL вышел за ваш лимит проскальзывания. Ничего не подписано.",
  "verify.badge": "Подтверждение покупки",
  "verify.title": "Проверить чек",
  "verify.intro": "Вставьте подпись транзакции Solana, чтобы проверить покупку напрямую в сети и в реестре SFN. Проверка выполняется на сервере — кошелёк подключать не нужно.",
  "verify.modalIntro": "Проверенный сервером статус в сети и соответствующая запись реестра.",
  "verify.label": "Подпись транзакции",
  "verify.placeholder": "Вставьте подпись транзакции Solana",
  "verify.submit": "Проверить чек",
  "verify.busy": "Проверяем…",
  "verify.close": "Закрыть проверку чека",
  "verify.verified": "Подтверждено в сети",
  "verify.unreachable": "Сеть недоступна — повторите позже",
  "verify.notConfirmed": "Не подтверждено",
  "verify.invalid": "Это не действительная подпись Solana.",
  "verify.rateLimited": "Слишком много запросов. Подождите минуту.",
  "verify.replay": "Вы уже проверяли эту подпись в этой сессии.",
  "verify.error": "Сервис проверки занят. Повторите попытку чуть позже.",
  "verify.receiptId": "ID чека",
  "verify.signature": "Подпись",
  "verify.ledgerEntry": "Запись реестра",
  "verify.purchase": "Покупка",
  "verify.value": "Стоимость",
  "verify.wallet": "Кошелёк",
  "verify.checks": "Проверки расчёта",
  "verify.noLedger": "Пока нет записи в реестре SFN для этой подписи. Если вы только что заплатили, подождите несколько секунд.",
  "verify.explorer": "Открыть в Solscan",
  "admin.csv.export": "Скачать CSV",
  "admin.csv.exportLabel": "Скачать реестр продаж в формате CSV",
  "dexRoadmap.title": "Дорожная карта ликвидности и индексации",
  "dexRoadmap.phase1": "Пресейл и запуск утилити",
  "dexRoadmap.phase2": "Strict List на Jupiter и пул ликвидности Raydium",
  "dexRoadmap.phase3": "Индексация на CoinGecko и CoinMarketCap",
  "dexRoadmap.active": "Активно",
  "dexRoadmap.status.active": "Активно",
  "dexRoadmap.status.next": "Следующий этап",
  "dexRoadmap.status.planned": "Запланировано",
  "dexRoadmap.statusLive": "Статус этапов дорожной карты обновляется в реальном времени.",
  "dexRoadmap.statusFallback": "Статус в реальном времени недоступен — показан опубликованный план.",
  "dexRoadmap.visit": "Открыть {name} в новой вкладке",
  "swap.quote.refreshing": "Обновляем курс…",
};
